<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <v-card>
      <v-form v-model="isValid" ref="Calcform">
        <v-card-title>Expense Receipt</v-card-title>
        <v-card-text>
          <div class="d-flex">
            <v-card-subtitle class="mt-n3">
              {{ imprestLine.expenseCode }}: {{ imprestLine.description }}
            </v-card-subtitle>
            <v-spacer></v-spacer>
            <v-chip
              small
              class="ma-2 font-weight-light"
              label
              color="light-blue lighten-5"
            >
              Balance:
              <v-divider vertical class="mx-3"></v-divider>
              {{ Currency || "KES" }} {{ balance | currencyFormat }}
            </v-chip>
          </div>

          <v-divider class="my-2" />

          <div
            v-for="(item, index) in formData"
            :key="index"
            class="mx-5 mt-5 pb-4 border-b border-gray-200"
          >
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="item.amount"
                  label="Expenditure Amount"
                  type="number"
                  min="0"
                  step="1"
                  :rules="rules.required"
                  outlined
                  dense
                />
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  v-model="item.description"
                  label="Receipt Number"
                  :rules="rules.required"
                  outlined
                  dense
                />
              </v-col>
            </v-row>

            <v-file-input
              accept="image/jpeg,image/png,application/pdf"
              @change="(file) => uploadFile(file, index)"
              :rules="rules.required"
              prepend-icon=""
              append-icon="mdi-paperclip"
              dense
              outlined
              label="Upload Document"
            >
              <template v-slot:selection="{ text }">
                <v-chip small label color="primary">{{ text }}</v-chip>
              </template>
            </v-file-input>

            <div class="d-flex justify-end mt-2" v-if="formData.length > 1">
              <v-btn
                small
                color="error"
                variant="text"
                @click="removeFormItem(index)"
              >
                Remove
              </v-btn>
            </div>

            <v-divider
              v-if="index < formData.length - 1"
              class="my-4"
            ></v-divider>
          </div>

          <div class="mx-5 mt-4">
            <v-btn color="secondary" variant="outlined" @click="addFormItem">
              + Add Another Receipt
            </v-btn>
          </div>
        </v-card-text>

        <v-card-actions class="pb-7 mr-6 mt-n3">
          <v-spacer />
          <v-btn class="mx-3" @click="setDialog = false" color="error" text>
            Cancel
          </v-btn>
          <v-btn @click="SaveImage" color="primary">Submit</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import helpers from "@kinetics254/cassandra-base/utilities/helpers/helper";

export default {
  name: "CalcImprest",

  props: {
    imprestLine: Object,
    dialog: Boolean,
    Currency: String,
  },

  data() {
    return {
      isValid: false,
      formData: [
        {
          attachment: "",
          description: "",
          amount: null,
        },
      ],
    };
  },

  computed: {
    setDialog: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit("close-dialog", val);
      },
    },

    balance() {
      const total = this.formData.reduce(
        (acc, item) => acc + (item.amount || 0),
        0
      );
      return this.imprestLine.balance - total;
    },

    rules() {
      return {
        required: [(v) => !!v || "This field is required"],
      };
    },
  },

  methods: {
    async uploadFile(file, index) {
      if (file) {
        const base64File = await helpers.toBase64(file);
        this.formData[index].attachment = base64File.split(",")[1];
      } else {
        this.formData[index].attachment = "";
      }
    },

    addFormItem() {
      this.formData.push({
        attachment: "",
        description: "",
        amount: null,
      });
    },

    removeFormItem(index) {
      this.formData.splice(index, 1);
    },

    SaveImage() {
      this.$refs.Calcform.validate();

      if (!this.isValid) return;

      const lines = this.formData.map((item) => ({
        ...item,
        DetailedLineMgtLineNo: this.imprestLine.lineNo,
        DetailedLineMgtDocNo: this.imprestLine.documentNo,
        DetailedLineMgtDocType: this.imprestLine.documentType,
      }));

      this.$store.dispatch("imprest/SaveImage", { lines });

      this.formData = [
        {
          attachment: "",
          description: "",
          amount: null,
        },
      ];

      this.setDialog = false;
    },
  },
};
</script>

<style scoped>
.border-b {
  border-bottom: 1px solid #e0e0e0;
}
</style>
